import { render, staticRenderFns } from "./InternetAndMobileLegalMentions.vue?vue&type=template&id=7463d2e4&scoped=true&"
import script from "./InternetAndMobileLegalMentions.vue?vue&type=script&lang=js&"
export * from "./InternetAndMobileLegalMentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463d2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7463d2e4')) {
      api.createRecord('7463d2e4', component.options)
    } else {
      api.reload('7463d2e4', component.options)
    }
    module.hot.accept("./InternetAndMobileLegalMentions.vue?vue&type=template&id=7463d2e4&scoped=true&", function () {
      api.rerender('7463d2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/InternetAndMobileLegalMentions.vue"
export default component.exports